"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotionTheming = require("emotion-theming");

var _Card = require("./Card.style");

var _CardSignpost = require("./CardSignpost.style");

var _Card2 = _interopRequireDefault(require("./Card"));

var _CardBadge = _interopRequireDefault(require("./CardBadge"));

var _MarkdownRenderer = _interopRequireDefault(require("../../MarkdownRenderer"));

var CardSignpost = function CardSignpost(_ref) {
  var image = _ref.image,
      label = _ref.label,
      title = _ref.title,
      copy = _ref.copy,
      link = _ref.link,
      banner = _ref.banner,
      bookmark = _ref.bookmark,
      onClickLabel = _ref.onClickLabel;

  var _ref2 = (0, _emotionTheming.useTheme)(),
      cards = _ref2.cards;

  return /*#__PURE__*/_react.default.createElement(_Card.Wrapper, {
    image: image
  }, banner && /*#__PURE__*/_react.default.createElement(_Card.CardBanner, banner), /*#__PURE__*/_react.default.createElement(_Card.CardContainer, null, image && bookmark && /*#__PURE__*/_react.default.createElement(_Card.BookmarkCta, {
    isActive: bookmark.isActive,
    onClick: bookmark.onClick
  }), /*#__PURE__*/_react.default.createElement(_Card2.default, {
    url: link === null || link === void 0 ? void 0 : link.url
  }, /*#__PURE__*/_react.default.createElement(_Card.Overlay, null, image && /*#__PURE__*/_react.default.createElement(_Card.CardImage, Object.assign({
    preserveStackingContext: true,
    mediaType: "backgroundImage"
  }, image), label && /*#__PURE__*/_react.default.createElement(_CardBadge.default, {
    label: label,
    bookmark: bookmark,
    onClickLabel: onClickLabel
  })), title && /*#__PURE__*/_react.default.createElement(_CardSignpost.CardSignpostContent, {
    image: image
  }, /*#__PURE__*/_react.default.createElement(_CardSignpost.CardSignpostTitle, null, title), /*#__PURE__*/_react.default.createElement(_CardSignpost.StyledIcon, {
    name: cards === null || cards === void 0 ? void 0 : cards.titleIcon
  }), /*#__PURE__*/_react.default.createElement(_CardSignpost.CardSignpostBody, null, /*#__PURE__*/_react.default.createElement(_MarkdownRenderer.default, {
    html: copy
  })))))));
};

CardSignpost.propTypes = {
  image: _propTypes.default.shape({
    src: _propTypes.default.string,
    fluid: _propTypes.default.shape({}),
    fixed: _propTypes.default.shape({})
  }),

  /** Card image label */
  label: _propTypes.default.string,

  /** Card Primary CTA - links to main title and image */
  title: _propTypes.default.string,
  copy: _propTypes.default.string,
  link: _propTypes.default.shape({
    /** card link URL */
    url: _propTypes.default.string
  }),
  banner: _propTypes.default.shape({
    image: _propTypes.default.shape({
      src: _propTypes.default.string,
      fluid: _propTypes.default.shape({}),
      fixed: _propTypes.default.shape({})
    }),
    label: _propTypes.default.string
  }),
  bookmark: _propTypes.default.shape({
    isActive: _propTypes.default.bool,
    onClick: _propTypes.default.func
  }),
  onClickLabel: _propTypes.default.func
};
CardSignpost.defaultProps = {
  label: null,
  title: '',
  copy: '',
  link: null,
  image: null,
  banner: null,
  bookmark: null,
  onClickLabel: null
};
var _default = CardSignpost;
exports.default = _default;